import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { ThemeProvider } from './ThemeContext';
import AppHeader from './components/AppHeader';
import HomePage from './pages/HomePage';
import PowerBi from './pages/PowerBi';
import SelfServicePage from './pages/SelfServicePage';
import AdminSelfServicePage from './pages/AdminSelfServicePage';
import GettingStartedPage from './pages/GettingStartedPage';
import CoreServicesPage from './pages/CoreServicesPage';
import BmnIntegrationPage from './pages/BmnIntegrationPage';


function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app-container bg-background-default">
          <AppHeader />
          <div className="app-main">
            <div className="app-content">
              <Routes>
                {/* Getting started viewer */}
                <Route path="/getting-started" element={<GettingStartedPage showBackButton={true}/>} />
                {/* Core services overview page */}
                <Route path="/core-services" element={<CoreServicesPage showBackButton={true}/>} />
                  {/* Prevent dev warning when location doesn't match these routes */}
                  <Route path="/finops" element={<PowerBi showBackButton={true} name="finops" />}/>
                  <Route path="/greenops" element={<PowerBi showBackButton={true} name="greenops" />}/>
                  <Route path="/tdp-asset" element={<PowerBi showBackButton={true} name="tdp-asset" />}/>
                  <Route path="/power-bi" element={<PowerBi showBackButton={true} name="incident" />} />
                  <Route path="*" element={null} />
              </Routes>
              <div className="app-page-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/bmn-integration" element={<BmnIntegrationPage />} />
                  <Route path="/admin/self-service" element={<AdminSelfServicePage />} />
                  <Route path="/self-service" element={<SelfServicePage showBackButton={true}/>} />
                  <Route path="*" element={null} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
